module.exports = __webpack_public_path__ + "static/media/ncaa-bg-cover.247a70fd.svg";